import styled from '../../../../styles/theme';
import NeedHelpSectionStyled from '../NeedHelpSectionStyled';
import { rem } from 'polished';

const NeedHelpSectionStyledAP = styled(NeedHelpSectionStyled)`
    background: ${({ theme }) => theme.colors.grey9};
    color: ${({ theme }) => theme.colors.grey1};

    .icon-wrapper {
        height: ${rem(20)} !important;
    }
`;

export default NeedHelpSectionStyledAP;
